import { Calendar, Flag, MapPin, Users } from "lucide-react";
import React from "react";
import AchievementReusableComponent from "../../utilitis/AchievementReusable";

const IndependentCelebration = () => {
  const achievementData = {
    title: "Independent Celebration",
    subtitle: "Uniting Cultures, Inspiring Futures",
    description:
      "Annual Independence celebration exchange events promoting understanding between Gambian and Indian cultures. This is celebrated every February 18th",
    images: [
      "https://i.ibb.co/TBPNys4/indian-dance-manav.jpg",
      "https://i.ibb.co/RCZYXjM/food-time.jpg",
      "https://i.ibb.co/pKhzRbw/Ghigh-Comissioner-agreement.jpg",
      "https://i.ibb.co/mcTzD49/gam-ind-ladies-manav.jpg",
      "https://i.ibb.co/XZpQvt6/adama-madam.jpg",
      "https://i.ibb.co/b5SgMX0/adama-podcasting.jpg",
      "https://i.ibb.co/ZNVg57y/physio-sports.jpg",
      "https://i.ibb.co/Dkfpdt6/high-personel-flower.jpg",
    ],
    iconTexts: [
      { icon: Calendar, text: "Annual Celebration" },
      { icon: MapPin, text: "Multiple Venues" },
      { icon: Users, text: "180+ Attendees" },
      { icon: Flag, text: "Cultural Exchange" },
    ],
    highlights: [
      "Traditional dance performances from both Gambian and Indian cultures",
      "Culinary exchange featuring authentic dishes from both countries",
      "Art exhibitions showcasing local and international talents",
      "Cultural workshops promoting hands-on learning experiences",
      "Guest speakers discussing the importance of cultural diversity",
    ],
    upcomingEvents: [
      {
        title: "Gambian Night",
        description: "A night of Gambian music, dance, and cuisine.",
        date: "August 15, 2024",
      },
      {
        title: "Indian Cultural Workshop",
        description: "Learn about Indian traditions, art, and history.",
        date: "September 5, 2024",
      },
      {
        title: "Joint Independence Day Celebration",
        description: "Commemorating the independence of both nations.",
        date: "October 2, 2024",
      },
    ],
    galleryLink: "/gallery",
  };

  return <AchievementReusableComponent {...achievementData} />;
};

export default IndependentCelebration;
